import { useRouter } from '@tanstack/react-router';
import { api } from '@/clients/admin.client';
import { notifyError, notifySuccess } from '@/lib/notification';
import { UserInviteForm, Invitation } from './UserInviteForm';
import { logger } from '@/lib/logger';
import { notifications } from '@mantine/notifications';
import { IconCheck } from '@tabler/icons-react';
import { rem } from '@mantine/core';

type Props = {
  adminClient: typeof api;
};

export function UserInvite({ adminClient }: Props) {
  const router = useRouter();
  const sendInvitations = async (invitations: Invitation[]) => {
    let completed = 0;
    let notificationId: string | null = null;
    for (const { email, role } of invitations) {
      try {
        // eslint-disable-next-line no-await-in-loop
        await adminClient.admin_v1_invite_user({
          email,
          role: role,
        });
        completed++;
        const props = {
          message: `${email} に招待メールを送信しました (${completed}件目)。`,
          loading: true,
          autoClose: false,
        };
        if (!notificationId) {
          notificationId = notifySuccess('', {
            ...props,
          });
        } else {
          notifications.update({
            id: notificationId,
            ...props,
          });
        }
      } catch (e) {
        logger.error(e);
        notifyError(`${email} の招待に失敗しました。`);
      }
    }
    await router.load();
    if (notificationId) {
      notifications.update({
        id: notificationId,
        message: `${completed}件の招待メールを送信しました。`,
        loading: false,
        icon: <IconCheck style={{ width: rem(18), height: rem(18) }} />,
        autoClose: true,
      });
    }
  };

  return (
    <>
      <UserInviteForm onSubmit={sendInvitations} />
    </>
  );
}
